import {
  Box,
  Stack,
  Step,
  StepIconProps,
  StepLabel,
  Stepper,
  Typography,
} from '@mui/material';
import StepConnector, {
  stepConnectorClasses,
} from '@mui/material/StepConnector';
import React from 'react';
import { styled } from '@mui/material/styles';
import { colors } from '../utils/theme';

export interface RootineStep {
  name: string;
  title?: string;
  icon: JSX.Element;
}

interface RootineStepIconProps extends StepIconProps {
  iconComponent: React.ReactElement;
  step: number;
}

export const RootineStepperV2 = ({
  steps,
  activeStep,
}: {
  steps: RootineStep[];
  activeStep?: number;
}) => {
  const RootineStepConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: colors.greys.GREY_700,
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: colors.greys.GREY_700,
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      borderTopWidth: 2,
    },
  }));

  const RootineStepIconRoot = styled('div')<{
    ownerState: { completed?: boolean; active?: boolean };
  }>(({ theme, ownerState }) => ({
    backgroundColor: ownerState.active
      ? colors.greens.SUCCESS_100
      : colors.greys.BASE_WHITE,
    zIndex: 1,
    color: ownerState.active
      ? colors.greens.SUCCESS_500
      : colors.greys.GREY_700,
    width: 48,
    height: 48,
    position: 'relative',
    top: -12,
    display: 'flex',
    borderRadius: ownerState.active ? 50 : 10,
    justifyContent: 'center',
    alignItems: 'center',
    border: !ownerState.active
      ? `1px solid ${colors.greys.BORDER_GREY}`
      : 'none',
  }));
  function RootineStepIcon(props: RootineStepIconProps) {
    const { active, completed, className, iconComponent, step } = props;

    return (
      <RootineStepIconRoot
        ownerState={{ completed, active: step <= (activeStep || 0) }}
        className={className}
      >
        {iconComponent}
      </RootineStepIconRoot>
    );
  }
  return (
    <Stack sx={{ width: '100%' }} spacing={4}>
      <Stepper
        alternativeLabel
        activeStep={activeStep}
        connector={<RootineStepConnector />}
      >
        {steps.map((step: RootineStep, index: number) => (
          <Step key={step.name}>
            <StepLabel
              StepIconComponent={(props) => (
                <RootineStepIcon
                  {...props}
                  iconComponent={step.icon}
                  step={index}
                />
              )}
            >
              <Box>
                <Typography
                  fontSize={16}
                  sx={{
                    color:
                      index <= (activeStep || 0)
                        ? colors.greys.GREY_700
                        : colors.greys.GREY_400,
                  }}
                >
                  {step.name}
                </Typography>
                <Typography
                  variant="light"
                  fontSize={16}
                  sx={{
                    color:
                      index <= (activeStep || 0)
                        ? colors.greys.GREY_700
                        : colors.greys.GREY_400,
                  }}
                >
                  {step.title}
                </Typography>
              </Box>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Stack>
  );
};
